import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';
 
@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
 
    constructor(
        public router: Router, 
        public authservice: AuthenticationService) {
    }

    /**
     * Verifica si el usuario se encuentra logueado / contiene token. Si es false, envía al login
     */
    canActivate(){
        let user =  JSON.parse(localStorage.getItem('currentUser'));
        // retorna true si el usuario tiene token
        if(user){
            this.authservice.setHeaders(user.token);
            return true;
        }
        // sino redirecciona a la pagina de login.
        this.router.navigate(['/login']);
        return false;
    }      
}